module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hKqDj"))).then(() => parcelRequire('1iHdE'));